module.exports = __webpack_public_path__ + "static/heathcote-gin-6a1a7249b3c3e93b18d8cab1af510535.jpg";